import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_PROFILE_ELIGIBILITY_NGEMR_PATIENT } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type {
  GetProfileEligibilityNgemrPatientPayload,
  GetProfileEligibilityNgemrPatientResult,
} from '../types/getProfileEligibilityNgemrPatient.types';

export const TAG_PE_NGEMR_PATIENT = 'PENgemrPatient';

export const getProfileEligibilityNgemrPatient = (builder: BuilderType) =>
  builder.query<GetProfileEligibilityNgemrPatientResult, GetProfileEligibilityNgemrPatientPayload>({
    providesTags: [TAG_PE_NGEMR_PATIENT],
    query: (params) => ({
      data: params,
      method: 'POST',
      url: GET_PROFILE_ELIGIBILITY_NGEMR_PATIENT,
    }),
    transformResponse: (response: GenericApiResponse<GetProfileEligibilityNgemrPatientResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
